import React, { useContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Header from './Header'
import PaymentInfo from './PaymentInfo'
import InvoiceSpecification from './InvoiceSpecification'
import Info from './Info'
import Advertisement from './Advertisement'
import Footer from './Footer'
import Payment from './Payment'
import Swish from './Swish'
import OneClick from './OneClick'
import SwishPending from './SwishPending'
import OneClickPayment from './OneClickPayment'
import PaymentInfoCustomer from './PaymentInfoCustomer'
import PaymentInfoInvoice from './PaymentInfoInvoice'
import Context from '../context/Context'
import styled, { ThemeProvider } from 'styled-components'
import SigningChoice from './SigningChoice'

const FallBackComponent = () => {
  return (
    <div>
      <PaymentInfoCustomer />
      <PaymentInfoInvoice />
    </div>
  )
}

const Routing = ({ params }) => {
  const context = useContext(Context)
  const [expandSpecification, setExpandSpecification] = useState(false)

  useEffect(() => {
    setExpandSpecification(!!parseInt(context.organizationSettings.expandSpecification))
  }, [context.organizationSettings.expandSpecification])

  function handleToggleSpecification (value) {
    setExpandSpecification(value)
  }

  const StyledDiv = styled.div`
      a:visited {
          color: ${context.organizationSettings.linkColor};
      }
      a:link {
          color: ${context.organizationSettings.linkColor};
      }
      a:active {
          color: ${context.organizationSettings.linkColor};
      }
  `

  const containerFonts = {
    '--font-default': context.organizationSettings.default,
    '--font-Header1': context.organizationSettings.fontHeader1,
    '--font-Header2': context.organizationSettings.fontHeader2,
    '--font-Button': context.organizationSettings.fontButton,
    '--font-Paragraph': context.organizationSettings.fontParagraph,
    '--font-InvoiceInformation-Header': context.organizationSettings.fontInvoiceInformationHeader,
    '--font-InvoiceInformation': context.organizationSettings.fontInvoiceInformation
  }

  return (
    <div style={{ background: context.organizationSettings.backgroundColor }}>
      <ThemeProvider theme={{ theme: context.organizationSettings.default }}>
        <div className='container' style={containerFonts}>
          <Header />
          <BrowserRouter>
            <Routes>
              <Route exact path="/" element={<PaymentInfo />} />

              <Route exact path="/payment" element={
                <Payment onToggleSpecification={handleToggleSpecification} />
              } />

              <Route exact path="/payment/swish" element={
                (context.organizationSettings.isSwishActive === '1')
                  ? <Swish />
                  : <FallBackComponent />
              } />

              <Route exact path="/payment/swish/pay" element={
                (context.organizationSettings.isSwishActive === '1')
                  ? <SwishPending />
                  : <FallBackComponent />
              } />

              <Route exact path="/payment/oneclick" element={
                (context.organizationSettings.isOneClickActive === '1')
                  ? <OneClick />
                  : <FallBackComponent />
              } />

              <Route exact path="/payment/oneclick/pay/:id/sign" element={
                (context.organizationSettings.isOneClickActive === '1')
                  ? <SigningChoice isLink={true} />
                  : <FallBackComponent />
              } />

              <Route exact path="/payment/oneclick/pay/:id/sign/:sign" element={
                (context.organizationSettings.isOneClickActive === '1')
                  ? <OneClickPayment />
                  : <FallBackComponent />
              } />
            </Routes>
          </BrowserRouter>
          <InvoiceSpecification
            onToggleSpecification={handleToggleSpecification}
            isToggled={expandSpecification} />

          <StyledDiv>
            <Info />
            <Advertisement />
            <Footer />
          </StyledDiv>
        </div>
      </ThemeProvider>
    </div>
  )
}

Routing.propTypes = {
  params: PropTypes.object
}

export default Routing
